import { CALCULATORS_ACTION_TYPE } from '../actions';

const initialState = {};

const calculatorsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CALCULATORS_ACTION_TYPE.GET_CALCULATORS:
      return payload || initialState;

    default:
      return state;
  }
};

export default calculatorsReducer;
